import { render } from "./TelaSync.vue?vue&type=template&id=6d8a7241&scoped=true"
import script from "./TelaSync.vue?vue&type=script&lang=js"
export * from "./TelaSync.vue?vue&type=script&lang=js"

import "./TelaSync.vue?vue&type=style&index=0&id=6d8a7241&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3986129723/src/app-csd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8a7241"]])

export default __exports__